import {WhitelabelDomainInfo} from '@graphql/generated';
import {createAction, props} from '@ngrx/store';

export const setVersion = createAction(
    '[App] Set Version',
    props<{ version: string }>()
);

export const setWhitelabel = createAction(
    '[App] Set Whitelabel Related Info',
    props<{ whitelabelDomainInfo: WhitelabelDomainInfo, whitelabelSource: 'host'|'login'}>()
);

export const resetAppState = createAction(
    '[App] Reset State'
);
